import { render, staticRenderFns } from "./VentaCartera.vue?vue&type=template&id=0ea320fc&"
import script from "./VentaCartera.vue?vue&type=script&lang=js&"
export * from "./VentaCartera.vue?vue&type=script&lang=js&"
import style0 from "./VentaCartera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports